// @owners { team: patients-team }
import { useCallback } from 'react';
// eslint-disable-next-line import/no-deprecated
import { fetchDeliveries } from '~shared/actions/deliveries';
// eslint-disable-next-line import/no-deprecated
import { fetchPrescriptionPricing } from '~shared/actions/pricing';
import getIsAuthorized from '~shared/selectors/auth/getIsAuthorized';
import { type configureStore } from '~web/configureStore';

/**
 * Fetches initial data (deliveries and prescription pricing)
 * Note: the redux store is passed into this hook because the redux provider
 * is rendered in PatientDashboardApp. This allows populating the redux state
 * and dispatching network request actions.
 * @returns
 */
export const useGetInitialData = ({ store }: { store: Pick<ReturnType<typeof configureStore>, 'store'> }) => {
  const getInitialData = useCallback(async () => {
    // @ts-expect-error correct call for store.getState
    const initialState = store.getState();
    const isAuthorized = getIsAuthorized(initialState);
    if (!isAuthorized) return;

    await Promise.all([
      // @ts-expect-error correct call for store.dispatch
      // eslint-disable-next-line import/no-deprecated
      store.dispatch(fetchDeliveries()),
      // @ts-expect-error correct call for store.dispatch
      // eslint-disable-next-line import/no-deprecated
      store.dispatch(fetchPrescriptionPricing()),
    ]);
  }, [store]);

  return { getInitialData };
};
